<template>
    <div class="level" :class="{ 'is-mobile': isMobile, 'is-baseline': isBaseline }">
        <div class="level-left">
            <div
                v-if="position === 'is-left'"
                class="level-item"
                :class="[clickable ? 'is-clickable' : '', disabled ? 'is-disabled' : '']"
                style="margin: 0"
                @click="() => (disabled ? null : $emit('click'))"
            >
                <e-icon v-bind="$attrs" :icon="icon" :size="size" />
            </div>
            <div
                class="level-item"
                :class="[
                    dense ? 'mx-1' : '',
                    expanded ? 'mx-2' : '',
                    clickable ? 'is-clickable' : '',
                    disabled ? 'is-disabled' : '',
                ]"
                @click="() => (disabled ? null : $emit('click'))"
            >
                <slot />
            </div>
            <div
                v-if="position === 'is-right'"
                class="level-item"
                :class="[clickable ? 'is-clickable' : '', disabled ? 'is-disabled' : '']"
                style="margin: 0"
                @click="() => (disabled ? null : $emit('click'))"
            >
                <e-icon v-bind="$attrs" :icon="icon" :size="size" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconText',

    props: {
        icon: {
            type: String,
            required: true,
        },

        size: {
            type: String,
            default: 'is-small',
        },

        position: {
            type: String,
            default: 'is-left',
        },

        dense: {
            type: Boolean,
            default: false,
        },

        expanded: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        clickable: {
            type: Boolean,
            default: false,
        },

        isMobile: {
            type: Boolean,
            default: false,
        },

        isBaseline: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
};
</script>

<style scoped>
.is-baseline {
    .level-item,
    .level-left,
    .level-right {
        align-items: baseline;
    }
}
</style>
